import { Skeleton } from "@/components-shared/ui/skeleton";
import { cn } from "@/lib/utils";
import { useAppSelector } from "@/redux/store";
import { format, isBefore, isSameDay, subDays } from "date-fns";
import { memo, useMemo } from "react";
import { DayButtonProps } from "react-day-picker";

const DayButton = ({
  day: dayPickerDay,
  modifiers,
  ...buttonProps
}: DayButtonProps) => {
  const date = useMemo(() => dayPickerDay.date, [dayPickerDay.date]);
  const days = useAppSelector((state) => state.monthPrices);

  const day = useMemo(
    () => days?.daysInMonth?.find((day) => isSameDay(day.date, date)),
    [days.daysInMonth, date]
  );

  return (
    <>
      {!modifiers?.isHidden && (
        <button
          {...buttonProps}
          className={cn("size-full border rounded", buttonProps.className, {
            "border-black": modifiers?.today,
            "text-neutral-500 opacity-50 dark:text-neutral-400  line-through":
              !day?.isAvailable ||
              (new Date().getHours() < 5
                ? isBefore(date, subDays(new Date(), 2))
                : isBefore(date, subDays(new Date(), 1))),
          })}
          type="button"
          aria-label={day?.currentValue?.toString() || ""}
        >
          <div className="flex flex-col justify-center items-center">
            <span>{format(date, "dd")}</span>
            {days?.isLoading ? (
              <Skeleton className="w-7 h-3" />
            ) : (
                day?.isAvailable && day?.currentValue && day?.currentValue > 0 && (
                <span className="!text-[8px] truncate">
                  {Number(day?.currentValue).toLocaleString("en-US")}
                </span>
              )
            )}
          </div>
        </button>
      )}
    </>
  );
};

export default memo(DayButton);
